import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NavigationOptions } from '../../../../../../shared/components/page-header-nav/models/navigation-options';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-go-application-buttons',
    imports: [MatButtonModule, RouterModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './go-application-buttons.component.html',
})
export class GoApplicationButtonsComponent {
    @Input() navItems: NavigationOptions = {
        primaries: [],
        secondaries: [],
        tertiaries: [],
        quaternaries: [],
    };
}
